import { DealStatus } from "@/constants/deal-statuses";
import _, {find, get, map} from 'lodash'
import store from '@/store'

export default {
    methods: {
        getExternalVehicleMaxTowing(additional_information) {
            let existing_info = find(additional_information, {name: 'Maximum Towing'});
            return get(existing_info, 'meta.value')
        },
        isMainBodyType(bodyType) {
            return this.mainBodyTypeIds.includes(bodyType.id)
        }
    },
    computed: {
        vehicleStatusLabel() {
            if (!this.vehicle) {
                return null;
            }

            if (DealStatus.holdRequest.value === this.vehicle.status) {
                return DealStatus.holdRequest.label;
            }

            if (DealStatus.onHold.value === this.vehicle.status) {
                return DealStatus.onHold.label;
            }

            if (_.includes([DealStatus.sold.value, DealStatus.completed.value], this.vehicle.status)) {
                return DealStatus.sold.label;
            }

            return 'Available'
        },
        vehicleStatusClass() {
            if (!this.vehicle) {
                return undefined;
            }

            switch (this.vehicle.status) {
                case DealStatus.enquiry.value:
                    return 'text-success';
                case DealStatus.holdRequest.value:
                    return 'text-warning';
                case DealStatus.onHold.value:
                    return 'text-danger';
                case DealStatus.sold.value:
                    return 'text-primary';
                case DealStatus.completed.value:
                    return 'text-info';
                default:
                    return null
            }
        },
        condition() {
            return get(this.vehicle, 'condition.name', null) || 'N/A';
        },
        color() {
            return get(this.vehicle, 'color.name', null) || 'N/A';
        },
        isWholesale() {
            return get(this.vehicle, 'company.is_wholesale')
        },
        isHidden() {
            if (!this.vehicle) {
                return undefined;
            }
            return !!this.vehicle.hid_at;
        },
        mainBodyTypeIds() {
            return map(store.state.body_types, (bodyType) => bodyType.id)
        },
    },
}
